module.exports = __webpack_public_path__ + "img/body-type.99646991.svg";